import YoutubeEmbed from "../YoutubeEmbed";
function build(txt, img, tre) {
  let struttura = [];
  let temp;
  struttura.push(<h2 className="subtitle">{txt[19]}</h2>);
  
  // DA CAMBIARE IL SITO!!
  temp = (
    <div className="video-container">
      <YoutubeEmbed embedId="REQyoCY4njU" />
    </div>
  );
  struttura.push(temp);

  temp = <div className="paragrafo">{txt[0]}</div>;
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[1]}
      {img[0]}
    </div>
  );
  struttura.push(temp);

  temp = <div className="paragrafo">{txt[2]}</div>;
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[1]}
      {img[2]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[3]}
      {img[3]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[4]}
      {txt[4]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[5]}
      {img[5]}
    </div>
  );
  struttura.push(temp); 

  temp = (
    <div className="paragrafo">
      {img[6]}
      {txt[6]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[7]}
      {img[7]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[8]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[8]}
      {txt[9]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[10]}
      {img[9]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[10]}
      {txt[11]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[12]}
      {img[11]}
    </div>
  );
  struttura.push(temp);

  temp = <div className="paragrafo">{txt[13]}</div>;
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[12]}
      {txt[14]}
    </div>
  );
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {txt[15]}
      {img[13]}
    </div>
  );
  struttura.push(temp);

  temp = <div className="paragrafo">{txt[16]}</div>;
  struttura.push(temp);

  temp = (
    <div className="paragrafo">
      {img[14]}
      {txt[17]}
    </div>
  );
  struttura.push(temp);

  temp = <div className="paragrafo">{img[15]}</div>;
  struttura.push(temp); // austriaci

  temp = <div className="note">{txt[18]}</div>;
  struttura.push(temp);

 

  return struttura;
}

export default build;
